import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { environment } from '@environments/environment';
import { ActivatedRoute, Router} from '@angular/router';
import { SidebarService } from '@ibe/services/ui';
import * as BookedTripActions from '@ibe/store/actions/booked-trip.actions';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../../store';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';
import { EXTRAS_ANCILLARY_STOPOVER_LISBOA_CARD, SESSION_VAR_KEY_CURRENCY } from '@ibe.config';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRAGoogleAnalyticsService, EVENT_ACTION_ADD_CART, EVENT_ACTION_REM_CART } from '@ibe.services/google.analytics.indra.service';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';

@Component({
  selector: 'app-lisboa-card-discount',
  templateUrl: './lisboa-card-discount.indra.component.html',
  styleUrls: ['./lisboa-card-discount.component.scss']
})
export class INDRALisboaCardDiscountComponent implements OnInit, OnDestroy {

	isAlive = true;
	city = 'Lisbon';
	environment = environment;
	form = new FormGroup({
		voucher: new FormControl('')
	});

	bookedTripExtras$: Observable<any> = this.store.select(fromStore.getSelectedBookedTripExtras);

	formChange = false;
	typeExtra = 'lisboa-card';

	lisboaCardAmount;
	extra;
	hasError;
	findExtra;
	
	isModificationDisallowed: boolean = false;
	lisbonCardIbeadminKey = 'externalURLs.lisbonCard';

	constructor(
		protected route: ActivatedRoute,
		protected router: Router,
		private sidebarService: SidebarService,
		private store: Store<fromStore.State>,
		private ancillaryService: INDRAAncillariesService,
		private currencyService: INDRACurrencyService,
		private googleAnalytics: INDRAGoogleAnalyticsService,
		private bfmStorage: INDRABFMDataStorageService,
		private ibeAdminConfigService: INDRAIbeAdminConfigService
	) {
		this.bookedTripExtras$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {

				if (value) {
					this.findExtra = value.find( cur => cur.type == this.typeExtra);
					if (this.findExtra) this.form.get('voucher').setValue(true, { emitEvent: false });
				}

			});
			
		// get 'isBookingCreated' if existing in URL query params (if true, modification in the sidebar is not allowed)
		const isBookingCreatedParam = this.route.snapshot.paramMap.get('isBookingCreated');
		if (isBookingCreatedParam === 'true') {
			this.isModificationDisallowed = true;
		}
	}

	ngOnInit() {
		this.form.valueChanges.pipe(takeWhile(() => this.isAlive)).subscribe(value => {
			this.formChange = true;
		});

		this.extra = this.sidebarService.getSidebarParameters();

		if (this.extra && this.extra.some(el => el['readOnly'])) {
			this.form.get('voucher').setValue(true);
		}
	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	INDRA_removeVoucher() {
		this.form.get('voucher').setValue('');
	}

	INDRA_addVoucher() {
		this.form.get('voucher').setValue(true);
	}

	INDRA_handleDone() {
		if (this.form.get('voucher').value) {
			// check if same extra was previously added else no need to call API again
			if (!this.findExtra) {
				const stopoverProvider = this.extra[0].selectedExtra[0].ancillaryList[0].type;

				const params: any = {
					provider: stopoverProvider,
					idReservation: this.extra[0].stopoverCode,
					stopOverInfo: {}
				};

				params.stopOverInfo[stopoverProvider] = {
					currency: this.currencyService.INDRA_getCurrencySymbol().name,
					amount: this.extra[0].selectedExtra[0].amount,
					status: 'OK'
				};

				this.ancillaryService.INDRA_addExternalReservation(params, EXTRAS_ANCILLARY_STOPOVER_LISBOA_CARD).subscribe(res => {
					if (res && res.status === '200' && res.reservations) {
						this.lisboaCardAmount = this.extra[0].selectedExtra[0].amount;
						this.store.dispatch(new BookedTripActions.PutBookedTripExtrasAction(
							{
								type: this.typeExtra,
								value: this.lisboaCardAmount,
								stopoverCity: this.extra[0].stopoverCode,
								selectedExtra: this.extra
							}
							));
						this.sidebarService.closeSidebar();
						this.INDRA_registerGA_lisboaCard(res.reservations);
					}
				}, err => {
					this.hasError = true;
				});
			} else {
				this.sidebarService.closeSidebar();
			}
		} else {
			if (this.findExtra) {
				this.ancillaryService.INDRA_removeStopoverExtra(EXTRAS_ANCILLARY_STOPOVER_LISBOA_CARD, this.extra[0].stopoverCode, this.extra[0].selectedExtra[0].ancillaryList[0].type).subscribe(res => {
					if (res && res.status === '200') {
						this.store.dispatch(new BookedTripActions.RemoveBookedTripExtraByCityAndTypeAction(
							{
								stopoverCity: this.extra[0].stopoverCode,
								type: this.typeExtra
							}
						));
						this.INDRA_removeGA_Extra(this.typeExtra, this.extra[0].stopoverCode )
						this.sidebarService.closeSidebar();
					}
				}, err => {
					this.hasError = true;
				});
			} else {
				this.sidebarService.closeSidebar();
			}
		}
	}

	INDRA_removeGA_Extra(type, extra) {
		const eventDataLayerObject = this.googleAnalytics.INDRA_createGA_ExternalAncillarySingleProduct(type, extra);
		eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(EVENT_ACTION_REM_CART);

		this.googleAnalytics.INDRA_GA_removeFromCart(sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY), eventDataLayerObject);
	}

	INDRA_registerGA_lisboaCard(extra) {
		const activeBooking = this.bfmStorage.INDRA_getActiveBookedTrip();
		activeBooking.lisboa_card = extra.SO_LISBON_DISCOUNT[0];
		const eventDataLayerObject = this.googleAnalytics.IBE_createGA_ExtrasProducts(activeBooking);
		eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(EVENT_ACTION_ADD_CART);

		this.googleAnalytics.INDRA_GA_addToCart(sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY), eventDataLayerObject);
	}


	INDRA_showHandleDone() {
		if (this.extra && this.extra.some(el => el['readOnly'])) {
			return false;
		} else {
			return this.formChange;
		}
	}
	
	INDRA_closeSidebar() {
		this.sidebarService.closeSidebar();
	}

	INDRA_goToURL() {
		const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(this.lisbonCardIbeadminKey);
		return window.open(urlIbeAdmin);
	}

}
